var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.319922,
    y: 0.15,
    width: 35.6998,
    height: 35.7,
    rx: 17.8499,
    fill: "#5865F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.319922,
    y: 0.15,
    width: 35.6998,
    height: 35.7,
    rx: 17.8499,
    stroke: "#F2F2F2",
    strokeWidth: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.18 9.65789C25.5229 8.89053 23.7458 8.32516 21.8878 8.00136C21.854 7.99511 21.8202 8.01073 21.8027 8.04196C21.5742 8.45218 21.321 8.98735 21.1438 9.40799C19.1454 9.10606 17.1572 9.10606 15.1998 9.40799C15.0225 8.978 14.7601 8.45218 14.5305 8.04196C14.5131 8.01177 14.4793 7.99615 14.4455 8.00136C12.5885 8.32413 10.8114 8.88949 9.15327 9.65789C9.13891 9.66414 9.12661 9.67456 9.11844 9.68808C5.74776 14.7701 4.82439 19.7273 5.27737 24.6229C5.27942 24.6469 5.29274 24.6698 5.31119 24.6843C7.53506 26.3325 9.68927 27.3331 11.8035 27.9964C11.8373 28.0068 11.8732 27.9943 11.8947 27.9662C12.3948 27.2769 12.8406 26.5502 13.2229 25.7859C13.2454 25.7412 13.2239 25.688 13.1778 25.6703C12.4706 25.3996 11.7973 25.0696 11.1496 24.6948C11.0984 24.6646 11.0943 24.5906 11.1414 24.5552C11.2777 24.4521 11.4141 24.3449 11.5442 24.2366C11.5678 24.2168 11.6006 24.2127 11.6282 24.2252C15.8833 26.1857 20.4899 26.1857 24.6948 24.2252C24.7225 24.2116 24.7553 24.2158 24.7799 24.2356C24.91 24.3439 25.0463 24.4521 25.1837 24.5552C25.2308 24.5906 25.2277 24.6646 25.1765 24.6948C24.5288 25.0769 23.8555 25.3996 23.1473 25.6693C23.1012 25.687 23.0807 25.7412 23.1033 25.7859C23.4937 26.5491 23.9395 27.2759 24.4304 27.9651C24.4509 27.9943 24.4878 28.0068 24.5216 27.9964C26.6461 27.3331 28.8003 26.3325 31.0241 24.6843C31.0436 24.6698 31.0559 24.6479 31.058 24.624C31.6001 18.964 30.15 14.0476 27.2138 9.68912C27.2066 9.67456 27.1944 9.66414 27.18 9.65789ZM13.8583 21.642C12.5772 21.642 11.5216 20.455 11.5216 18.9974C11.5216 17.5397 12.5567 16.3528 13.8583 16.3528C15.17 16.3528 16.2154 17.5501 16.1949 18.9974C16.1949 20.455 15.1598 21.642 13.8583 21.642ZM22.4976 21.642C21.2165 21.642 20.161 20.455 20.161 18.9974C20.161 17.5397 21.196 16.3528 22.4976 16.3528C23.8094 16.3528 24.8547 17.5501 24.8342 18.9974C24.8342 20.455 23.8094 21.642 22.4976 21.642Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.4eb0c847e23443a9eb76b317d7698ed0.svg";
export { ForwardRef as ReactComponent };